<script lang="ts" setup>
  import type { RoundResultsView } from '../../../../shared/api/round.ts';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import RoundHeader from './RoundHeader.vue';
  import RoundResultList from './RoundResultList.vue';

  defineProps<{ data: RoundResultsView; secondsLeft: string; isHost: boolean }>();
</script>

<template>
  <MobileViewLayout space="m" overflow="hidden">
    <template #header>
      <RoundHeader :is-host="isHost" :seconds-left="secondsLeft" :view="data" />
    </template>

    <slot />

    <RoundResultList
      :chooser-player="data.round.chooser"
      :seconds-left="secondsLeft"
      :player="data.player"
      :song-submission-scores="data.round.songSubmissionScores"
    />
  </MobileViewLayout>
</template>
